import { PDFDocument } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import { toast } from "react-toastify";

import formatearNumero from "../datos/formatearNumero";
import formatearFecha from "../../helpers/datos/formatearFecha";

import { obtenerNombreMunicipio } from "../catalogos/metodos/obtenerNombreMunicipio";
import { obtenerNombreLocalidad } from "../catalogos/metodos/obtenerNombreLocalidad";
import { obtenerNombreArea } from "../usuario/obtenerNombreArea";

import formatearDatosAdicionales from "../datos/formatearDatosAdicionales";

/**
 * Obtener poliza de pago del historial
 * @param {Object} poliza 
 * @param {Object} data 
 */
export const generarPDFPorFolio = async (polizas, data, usuario) => {
    const poliza = polizas[0];

    var datosAdicionales = poliza.datosAdicionales;
    let sumaTotal = 0;
    try {
        const { contribuyente, direcciones } = data;
        const direccion = direcciones[0];
        const formUrl = "/plantila_orden_pago_formulario.pdf";
        const formPdfBytes = await fetch(formUrl).then(res => res.arrayBuffer());

        const fontUrl = "/ConnectCode39.ttf";
        const fontBytes = await fetch(fontUrl).then(res => res.arrayBuffer());
        const pdfDoc = await PDFDocument.load(formPdfBytes);
        pdfDoc.registerFontkit(fontkit);

        const customFont = await pdfDoc.embedFont(fontBytes);
        const form = pdfDoc.getForm();
        const barcodeField = form.getTextField("codigoBarras_")
        barcodeField.setFontSize(12);
        barcodeField.setText("*" + poliza.lineaCaptura + "*" ?? "");
        barcodeField.updateAppearances(customFont);
        const referenciaBancaria = form.getTextField("referenciaBancaria_")
        referenciaBancaria.setText(poliza.lineaCaptura ?? "");
        referenciaBancaria.setFontSize(8);
        form.getTextField("folio_").setText(String(poliza.idPolizaPago) ?? "");

        const rfcField = form.getTextField('RFC_');
        const curpField = form.getTextField("CURP_");
        const cpField = form.getTextField("CP_");
        const nombreField = form.getTextField("nombre_");
        rfcField.setText(contribuyente.rfc ?? "");
        rfcField.setFontSize(7);
        curpField.setText(contribuyente.curp ?? "");
        curpField.setFontSize(7);
        cpField.setText(direccion?.codigoPostal ?? "");
        cpField.setFontSize(7);
        nombreField.setText(`${contribuyente.apellidoPaterno} ${contribuyente.apellidoMaterno} ${contribuyente.nombre}`);
        nombreField.setFontSize(7);

        const calleField = form.getTextField("calle_");
        const noExteriorField = form.getTextField("noExterior_");
        const noInteriorField = form.getTextField("noInterior_");
        const telefonoField = form.getTextField("telefono_");
        calleField.setText(direccion?.calle ?? "");
        calleField.setFontSize(7);
        noExteriorField.setText(direccion?.numeroExterior ?? "");
        noExteriorField.setFontSize(7);
        noInteriorField.setText(direccion?.numeroInterior ?? "");
        noInteriorField.setFontSize(7);
        telefonoField.setText(direccion?.telefono ?? "");
        telefonoField.setFontSize(7);

        const coloniaField = form.getTextField("colonia_");
        const localidadField = form.getTextField("localidad_");
        const municipioField = form.getTextField("municipio_");
        coloniaField.setText(direccion?.colonia ?? "");
        coloniaField.setFontSize(7);
        localidadField.setText(await obtenerNombreLocalidad(direccion?.idLocalidad) ?? "");
        localidadField.setFontSize(7);
        municipioField.setText(await obtenerNombreMunicipio(direccion?.idMunicipio) ?? "");
        municipioField.setFontSize(7);

        const areaField = form.getTextField("area_");
        const datosAdicionalesField = form.getTextField("observaciones_");
        datosAdicionalesField.setText(formatearDatosAdicionales(datosAdicionales).toUpperCase());
        datosAdicionalesField.setFontSize(7);
        areaField.enableMultiline()
        areaField.setText(`${await obtenerNombreArea(1)} - DIRECCIÓN DE REGISTRO`);
        areaField.setFontSize(6);

        for (let i = 0; i < polizas.length; i++) {
            var criField = form.getTextField(`CRI_${i + 1}`)
            var descField = form.getTextField(`descripcion_${i + 1}`);
            var importeField = form.getTextField(`importe_${i + 1}`);
            criField.setText(String(polizas[i].cri) ?? "");
            descField.setText(polizas[i].descripcion.toUpperCase() ?? "");
            importeField.setText(`$${formatearNumero(Number.parseFloat(polizas[i].importeConcepto).toFixed(2))}`);
            criField.setFontSize(7);
            descField.setFontSize(6);
            importeField.setFontSize(7);

            sumaTotal = sumaTotal + Number(polizas[i].importe);
        }

        const fechaLimiteField = form.getTextField("fechaLimite_");
        fechaLimiteField.setText(formatearFecha(poliza.fechaVencimiento));
        fechaLimiteField.setFontSize(7);
        const importFinal = form.getTextField("total_");
        importFinal.setText(`$${formatearNumero(polizas[0].importe.toFixed(2))}`);
        importFinal.setFontSize(7);
        form.getTextField("usuario_").setText(usuario);

        form.getTextField("fecha_").setText(`${formatearFecha(poliza.fechaEmision)} ${poliza.horaEmision}`);

        form.flatten();

        // Guardar el archivo PDF llenado
        const pdfBytes = await pdfDoc.save();

        // Puedes descargar el PDF llenado utilizando un objeto Blob
        const blob = new Blob([pdfBytes], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.target = "_blank"
        /* link.download = "Orden de pago.pdf"; */
        link.click();
    }
    catch (error) {
        toast.error("Imposible cargar PDF: " + error.message, {
            position: "top-right",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }
}